import {computed, inject, provideAppInitializer, Signal, signal} from "@angular/core";
import {MediaMarshaller, MediaObserver, BreakPoint} from "@ngbracket/ngx-layout";

const breakpoints = signal<BreakPoint[]>([]);
const observer = signal<MediaObserver|null>(null);
const marshaller = signal<MediaMarshaller|null>(null);
export interface ScreenSize {
  is: (val: string|readonly string[]) => boolean;
  toString: () => string|null;
  [Symbol.toPrimitive]: () => string|null;
  valueOf: () => string|null;
}
export const screenSize: Signal<ScreenSize> = computed(() => {
  // breakpoints are just used to track changes since MediaObserver ovservable only fires on activations
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const bp = breakpoints();
  const obs = observer();
  const mshlr = marshaller();
  if (!obs) {
    return {
      is: () => false,
      toString: () => null,
      [Symbol.toPrimitive]: () => null,
      valueOf: () => null,
    }
  }
  return ({
    is: (val: string|readonly string[]) => obs.isActive(val as string|string[]),
    toString: () => mshlr?.activatedAlias ?? null,
    [Symbol.toPrimitive]: () => mshlr?.activatedAlias ?? null,
    valueOf: () => mshlr?.activatedAlias ?? null,
  });
})

export function provideScreenSizeVars() {
  return provideAppInitializer(() => {
    const obs = inject(MediaObserver);
    const mshlr = inject(MediaMarshaller);
    observer.set(obs);
    marshaller.set(mshlr);

    obs.asObservable().subscribe(() => {
      breakpoints.set(mshlr.activatedBreakpoints.slice());
    })
  })
}
